<ng-container *ngIf="instanceType === 'plain'">
  <div class="signature-general-content " id="signature-container1">
    <div class="signature-container">

      <div class="signature-buttons">
        <h4 style="color: var(--app-dim-white); padding: 0; margin: 0; width: 100%; text-align: left;">
          Sign as centered as possible
          <mat-icon>gesture</mat-icon>
        </h4>
        <button mat-raised-button class="btn-clear-sign" (click)="clear()">
          <mat-icon>change_circle</mat-icon>
        </button>
        <button mat-raised-button class="btn-undo-sign" (click)="undo()">
          <mat-icon>reply</mat-icon>
        </button>
      </div>
      <div style="position: relative">
        <canvas class="signature-pad canvas-signature" id="canva-signature1" #canvas1 width="900" height="200"
          style="touch-action: none;"></canvas>
      </div>
      <!-- <div class="row text-center" *ngIf="ownerName">
        <p style="width: 100%">
          {{ownerName}}
        </p>
      </div> -->
    </div>
  </div>
</ng-container> <!-- para instancias planas -->

<ng-container *ngIf="instanceType === 'modal'">
  <mat-toolbar>
    <span class="fill-remaining-space">
      <mat-icon>credit_card</mat-icon>
      Card Info
    </span>
    <button class="btn-dialog-close" mat-stroked-button (click)="onClose()">
      <mat-icon>clear</mat-icon>
    </button>
  </mat-toolbar>

  <mat-dialog-content>
    <div class="signature-general-content " id="signature-container1">
      <div class="signature-container">

        <div class="signature-buttons">
          <h4 style="color: var(--app-dim-white); padding: 0; margin: 0; width: 100%; text-align: left;">
            Sign as centered as possible
            <mat-icon>gesture</mat-icon>
          </h4>
          <button mat-raised-button class="btn-clear-sign" (click)="clear()">
            <mat-icon>change_circle</mat-icon>
          </button>
          <button mat-raised-button class="btn-undo-sign" (click)="undo()">
            <mat-icon>reply</mat-icon>
          </button>
        </div>
        <div style="position: relative">
          <canvas class="signature-pad canvas-signature" id="canva-signature1" #canvas1 width="900" height="200"
            style="touch-action: none;"></canvas>
        </div>
        <!-- <div class="row text-center" *ngIf="ownerName">
          <p style="width: 100%">
            {{ownerName}}
          </p>
        </div> -->
      </div>
    </div>

    <div style="text-align: justify; width: 535px;" id="authorize-txt">
      I <b>{{ownerName}}</b> authorize GUSA Capital to charge my {{ cardType }} with number
      <b>{{c_cn4}}</b>,
      expiration date <b>{{c_month}}</b> / <b>{{c_year}}</b> the amount of
      <b>{{amount | currency}}</b> <b>&nbsp;{{currency}}</b> (including taxes) for
      the enrollment fee for the Flyback program on the following date:
      <b>{{chargeDate}}</b>.
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close>Cancel</button>
    <button mat-raised-button (click)="saveSign()" color="primary">Add Signature</button>
  </mat-dialog-actions>

</ng-container> <!-- si es modal -->


